import { Link, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 w-full flex items-center justify-center px-4 py-16 md:py-24">
        <div className="max-w-xl w-full text-center">
          <p className="font-heading text-6xl md:text-8xl font-black text-primary-200 select-none">404</p>
          <h1 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            这个页面暂时找不到
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            你访问的地址可能已经调整，或者事件页的链接被修改过。
            可以回到首页看看今日热榜，或者从下面的栏目里挑一个继续浏览。
          </p>
          <p className="mt-2 text-xs text-foreground-400 break-all">{location.pathname}</p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="px-5 py-2.5 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/#topics"
              className="px-5 py-2.5 text-sm rounded-md border border-background-300 text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              浏览主题分类
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}